import React, { useState, useEffect } from "react";
import Select from "react-select";
import { FaTrash,FaPlus } from 'react-icons/fa';
import { Search } from 'lucide-react';
import classes from "./StaffLoan.module.css"
import { toast, ToastContainer } from 'react-toastify';
import plus from "../../../Assets/plus.svg"
import EyeIcon from "../../../Assets/new-eye.svg"
import DeleteIcon from "../../../Assets/new-delete.svg"
import PencilIcon from "../../../Assets/pencil.svg"
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiDeleteBinLine } from "react-icons/ri";
import { Spinner, Badge, Button, Modal, Form,Row,Col} from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';
import HeaderNav from "../../Accoungting/HeaderNav/HeaderNav";
import axios from "axios";
import { BASE_URL } from "../../../Components/Styles/API/API";
import { useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import download from "../../../Assets/download1.svg"
import upload from "../../../Assets/upload.svg"
import logo from "../../../Assets/rotating-logo.png";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Swal from 'sweetalert2';
import StaffLoanModal from "../../Accoungting/HeaderNav/Journal/StaffLoanUpload";

import { FaFileExcel } from "react-icons/fa6";
import { FaFilePdf } from "react-icons/fa";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";






const StaffLoan = () => {
  const [selectedOption, setSelectedOption] = useState(null);
   const [allAccounts, setAllAccounts] = useState([]);
     const [loans, setLoans] = useState([]);
   const [fetchingLoading, setFetchingLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
     const [selectedBank, setSelectedBank] = useState('');
       const [income, setIncome] = useState([]);
   const [uploading, setUploading] = useState(false);
  const [searchedResult, setSearchedResult] = useState([]);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [bearer, setBearer] = useState('');
  const [user, setUser] = useState('');
    const [error, setError] = useState(null);
   const [entriesPerPage, setEntriesPerPage] = useState(100);
    const [selectedLoan, setSelectedLoan] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalEntries, setTotalEntries] = useState("");
  const [loanCode, setLoanCode] = useState("");
  const [loanDescription, setLoanDescription] = useState("");
  const [selectedReportTo, setSelectedReportTo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [show1, setShow1] = useState(false);
  const [tableData, setTableData] = useState([]);
   const navigate = useNavigate();
  const [benLoading, setBenLoading] = useState(false);
  const [statLoading, setStatLoading] = useState(false);
  const [stat, setStat] = useState([]);
  const [minDate, setMinDate] = useState("");
  const [maxDate, setMaxDate] = useState("");
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedEndDate, setSelectedEndDate] = useState('');
  const [accounts, setAccounts] = useState([]);
  const [inputss, setInputss] = useState([]);
  const [loadings, setLoadings] = useState(false);
  const [description, setDescription] = useState('');
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [customerList, setCustomerList] = useState([]);
  const [selectedDebitAccount, setSelectedDebitAccount] = useState(null);
  const [debit1, setDebit1] = useState([]);
      const [incomeLoading, setIncomeLoading] = useState(false);
  const [foundRemitance,setFoundRemitance] = useState([]);
  const [totalCredit, setTotalCredit] = useState(0);
  const [incomeAmount, setIncomeAmount] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [ledgTableData, setLedgTableData] = useState([]);
 const [load, setLoad] = useState(false);
  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  const [formData, setFormData] = useState([]);
    const [openJournalModal, setOpenJournalModal] = useState(false);

  //      const [formData, setFormData] = useState(() => {
  //     return (
  //         foundRemitance?.items?.map((item, index) => ({
  //             sn: index + 1,
  //             accountName: item.item?.id,
  //             accountCode: item.item?.gl_code,
  //             amount: item.amount,
  //         })) || []
  //     );
  // });
  const [actionLoading, setActionLoading] = useState(null); 

   const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      const value1 = await localStorage.getItem('tobi');

      if (value !== null) {
        setBearer(value);
      }
      if (value1 !== null) {
        setUser(value1);
      }
    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

   const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };

  const handleShow1 = (loan) => {
    setLoanCode(loan.code);
    setLoanDescription(loan.description);
    setSelectedReportTo(loan.reportTo);
    setShow1(true);
  };

  const handleClose1 = () => setShow1(false);


  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

const fetchBooking = async (loanId = null) => {
  setIsLoading(true);
  try {
    let response;

    if (loanId) {
      // Use filter endpoint if loanId is provided
      response = await axios.get(
        `${BASE_URL}/account/filter-staff-loan?id=${loanId}&page=${currentPage}`,
        { headers }
      );
    } else {
      // Use default endpoint if no filter
      response = await axios.get(
        `${BASE_URL}/account/fetch-staff-loan?page=${currentPage}`,
        { headers }
      );
    }

    const results = response.data?.data?.data;
    const total = response.data?.data?.total;
    const lastPage = response.data?.data?.last_page || 1;

    setTotalEntries(total);
    setTableData(results);
    setTotalPages(lastPage);

    console.log(response);
  } catch (error) {
    if (error.response && error.response.status === 401) {
      navigate('/login');
    } else {
      console.log(error);
      setTableData([]);
    }
  } finally {
    setIsLoading(false);
  }
};

  useEffect(() => {
    if (bearer) {
      fetchBooking();

    }
  }, [bearer]);

   const fetchAccounts = async () => {
        setFetchingLoading(true);
        try {
            const response = await axios.get(`${BASE_URL}/reports/searchReceiptByCode`, {
                params: {
                    credit_gl_code: selectedBank,
                    start_date: selectedDate,
                    end_date: selectedEndDate
                },
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${bearer}`
                }
            });

            const resultsss = response.data?.data?.receipt;
            setAccounts(resultsss);

            const resultssx = response.data?.data?.input;
            setInputss(resultssx);

            console.log(resultsss);

            if (resultsss?.length > 0) {
                navigate('/cash_management/print_income', {
                    state: {
                        document: resultsss,
                        inputs: resultssx
                    }
                });
            } else {
                // toast.error('No data for the selected account');
            }
        } catch (error) {
            let errorMessage = 'An error occurred. Please try again.';
            if (error.response && error.response.data && error.response.data.message) {
                if (typeof error.response.data.message === 'string') {
                    errorMessage = error.response.data.message;
                } else if (Array.isArray(error.response.data.message)) {
                    errorMessage = error.response.data.message.join('; ');
                } else if (typeof error.response.data.message === 'object') {
                    errorMessage = JSON.stringify(error.response.data.message);
                }
            }
            // toast.error(errorMessage);
            console.log(errorMessage);
        } finally {
            setFetchingLoading(false);
        }
    };


      const fetchAccountss = async () => {
        console.log(headers)
        setLoadings(true);

        try {
            const response = await axios.get(`${BASE_URL}/account`, { headers });

            const CustomOption = (props) => {
              const { data, innerRef, innerProps } = props;
              return (
                <div ref={innerRef} {...innerProps}>
                  <span style={{ color: 'blue' }}>{data?.gl_code}</span>
                  {' - '}
                  <span style={{ color: 'red', fontWeight: 'bold' }}>{data?.gl_name}</span>
                </div>
              );
            };

            const allAccts = response.data?.data;
            const opt1 = allAccts.map((item) => ({
                label: `${item.gl_code} - ${item.gl_name}`,
                value: item.id,
            }));
            setAllAccounts(opt1);

            //   console.log(allAccts, "All Accounts");
        } catch (error) {
            const errorStatus = error.response?.data.message;
            console.error(errorStatus);
        } finally {
            setLoadings(false);
        }
    };

 useEffect(() => {
    if (bearer) {
        fetchAccountss();
    }
}, [bearer]);


function formatDate(dateString) {
    const date = new Date(dateString);
    const formattedDate = `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())} ${padZero(date.getHours())}:${padZero(date.getMinutes())} ${date.getHours() >= 12 ? 'PM' : 'AM'}`;
    return formattedDate;
  }

  function padZero(num) {
    return num < 10 ? `0${num}` : num;
  }

  const handlePrevPage = () => {
    setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
  };
  
  const handleNextPage = () => {
    setCurrentPage(prevPage => Math.min(prevPage + 1, totalPages));
  };

const formattedTotalEntries = totalEntries.toLocaleString();

 const fetchStat = async () => {
    setStatLoading(true);
    try {
        const response = await axios.get(`${BASE_URL}/customer/total-customers`, { headers });
        const stas = response.data?.data;
       
        setStat(stas);
     
    } catch (error) {
        if (error.response && error.response.status === 401) {
            navigate('/login');
        } else {
          let errorMessage = 'An error occurred. Please try again.';
          if (error.response && error.response.data && error.response.data.message) {
              if (typeof error.response.data.message === 'string') {
                  errorMessage = error.response.data.message;
              } else if (Array.isArray(error.response.data.message)) {
                  errorMessage = error.response.data.message.join('; ');
              } else if (typeof error.response.data.message === 'object') {
                console.log(errorMessage);
              }
          }
            setStat([]);
        }
    } finally {
        setStatLoading(false);
    }
};

useEffect(() => {
    if (bearer) {
      fetchStat();

    }
  }, [bearer]);

   const fetchLoans = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/account/fetch-loans`, { headers });
      const results = response.data?.data;

      const options1 = results.map((item) => ({
        label: item.description,
        value: item.id,
        interest: item.interest
      }));
      setLoans(options1);
    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (bearer) {
      fetchLoans();
    }
  }, [bearer]);

  const fetchAllStaffLoans = async (loanId = null) => {
  try {
    let allData = [];
    let currentPage = 1;
    let lastPage = 1;

    do {
      let response;

      if (loanId !== null && loanId !== undefined) {
        // 🔍 FILTERED STAFF LOANS
        response = await axios.get(
          `${BASE_URL}/account/filter-staff-loan`,
          {
            headers,
            params: {
              id: loanId,
              page: currentPage,
              per_page: 100,
            },
          }
        );
      } else {
        // 📄 ALL STAFF LOANS
        response = await axios.get(
          `${BASE_URL}/account/fetch-staff-loan`,
          {
            headers,
            params: {
              page: currentPage,
              per_page: 100,
            },
          }
        );
      }

      const pageData = response.data?.data?.data || [];
      lastPage = response.data?.data?.last_page || 1;

      allData = allData.concat(pageData);
      currentPage++;
    } while (currentPage <= lastPage);

    return allData;
  } catch (error) {
    console.error("Failed to fetch all staff loans:", error);
    return [];
  }
};


  const handleLoanTypeChange = (selectedOption) => {
    const loanId = selectedOption?.value || null;
    setSelectedLoan(selectedOption.value);
    fetchBooking(selectedOption?.value);
    fetchAllStaffLoans(loanId);
  }
  
    const fetchCustomers = async () => {
      setLoading(true);
  
  
      try {
        const response = await axios.get(
          `${BASE_URL}/customer/no-pagination`,
          {
  
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${bearer}`
            }
          }
        );
        const custome = response.data?.data;
        const customs = custome.map(item => ({
          label: item.name,
          value: item.id,
          balance: item.balance
        }));
        setCustomerList(customs);
        if (foundRemitance && foundRemitance.id) {
          const selectedCust = customs.find(item => item.value === foundRemitance.customer.id);
         console.log(selectedCust);
          setSelectedCustomer(selectedCust);
        }
      
        // setAddress(custome);
  
        console.log(response, "itss");
      } catch (error) {
        const errorStatus = error.response.data.message;
        console.error(errorStatus);
      } finally {
        setLoading(false);
      }
    };
  
    useEffect(() => {
      if (bearer) {
        fetchCustomers();
      }
    }, [bearer,foundRemitance]);

  const formatStat = (value) => {
  if (value == null) return "";

  if (value >= 1000 && value < 1000000) {
    const rounded = value / 1000;
    // If divisible by 1000 exactly, no decimals (30k)
    if (value % 1000 === 0) {
      return `${rounded}k`;
    }
    // Else show 2 decimals (30.01k)
    return `${rounded.toFixed(2)}k`;
  }

  if (value >= 1000000) {
    const rounded = value / 1000000;
    if (value % 1000000 === 0) {
      return `${rounded}M`;
    }
    return `${rounded.toFixed(2)}M`;
  }

  // smaller than 1000 → just locale string with commas
  return value.toLocaleString("en-US");
};

const isSearching = searchTerm.trim() !== "" && searchedResult.length > 0;
 const handleDateChange1 = (event) => {
        setSelectedEndDate(event.target.value);
    };

 const handleDateChange = (event) => {
        setSelectedDate(event.target.value);
    };

    const createIncome = async () => {
    setIncomeLoading(true);

    try {
        const accountNames = formData.map((row) => row.accountName).filter((name) => name !== undefined);
        const amounts = formData.map((row) => row.amount).filter((amount) => amount !== undefined);
        const payload = {
          id: foundRemitance?.id,
            account_id: accountNames,
            debit_gl: selectedDebitAccount?.value || '',
            description: description,
            customer_id: selectedCustomer?.value || '',
            // payment_mode: selectedPayment,
            amount: amounts,
            total_credit: totalCredit,
            total_debit: incomeAmount,
            // teller_no: teller,
            // particulars: receive,
            // currency: selectedCurrency,
            transaction_date: selectedDate,
            // bank_id: selectedBanks
        };

        console.log("Payload:", payload);

        const response = await axios.post(`${BASE_URL}/update-remittance`, payload, { headers });

        console.log(response.data, "Response Data");
        navigate(-1);
        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: response.data.message,
        });

        // toast.success(response.data.message);
    } catch (error) {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
              errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
              errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
              errorMessage = JSON.stringify(error.response.data.message);
              // toast.error(errorMessage);
            }
            console.log(error);
            Swal.fire({
              icon: 'error',
              title: 'Failed',
              text: JSON.stringify(error.response.data.message),
            });
        }
    } finally {
        setIncomeLoading(false);
    }
};

   const fetchReceipt = async () => {
        setLoad(true);
        try {
            const response = await axios.get(`${BASE_URL}/fetch-pending-sales-invoice-paginated?page=${currentPage}`, { headers });
            const results = response.data?.data?.data;
            const resultx = response.data?.data?.total;
            setLedgTableData(results);
            const total = response.data?.data?.last_page || 1;
            setTotalPages(total);
            console.log("fetched Receipts:", results);
            // toast.success(response.data.message);
        } catch (error) {
            if (error.response && error.response.status === 401) {
                navigate('/login');
            } else {
                let errorMessage = 'An error occurred. Please try again.';
                if (error.response && error.response.data && error.response.data.message) {
                    if (typeof error.response.data.message === 'string') {
                        errorMessage = error.response.data.message;
                    } else if (Array.isArray(error.response.data.message)) {
                        errorMessage = error.response.data.message.join('; ');
                    } else if (typeof error.response.data.message === 'object') {
                        toast.error(errorMessage)
                        console.log(errorMessage);
                    }
                }
                // setTableData([]);
            }
        } finally {
            setLoad(false);
        }
    };



    useEffect(() => {
        if (bearer) {
            fetchReceipt();

        }
    }, [bearer, currentPage]);
    

     const calculateTotalCredit = () => {
        const total = formData.reduce((acc, item) => acc + parseFloat(item.amount || 0), 0);
        const formattedTotal = total.toFixed(2);
        setTotalCredit(formattedTotal);
    };


    useEffect(() => {

        calculateTotalCredit();
    }, [formData]);


 const handleBank = (selectedOption) => {
        setSelectedBank(selectedOption.value);
    };
  const handleValueChange1 = (value, index) => {
        const updatedFormData = [...formData];
        updatedFormData[index] = {
            ...updatedFormData[index],
            amount: value,
        };
        setFormData(updatedFormData);
        calculateTotalCredit(); // Recalculate total credit whenever table amounts change
    };
    const goBack = () => {
        navigate(-1);
    }


     const handleAccountChange = (index, event) => {
        const selectedAccount = event.target.value;
        const intselectedId = parseInt(selectedAccount);
        const selectedGlCode = income.find((item) => item.id === intselectedId)?.gl_code || '';

        const updatedFormData = [...formData];
        updatedFormData[index] = {
            ...updatedFormData[index],
            accountName: selectedAccount,
            accountCode: selectedGlCode,
        };

        setFormData(updatedFormData);
    };

    const handleCreate = () => {

    }
       const addRow = () => {
        const newRow = {
            sn: formData.length + 1,
            accountName: '',
            accountCode: '',
            amount: ''
        };
        setFormData([...formData, newRow]);
        // setSelectedPayment('');
    };

    const deleteRow = (index) => {
        const updatedData = formData.filter((_, i) => i !== index);
        setFormData(updatedData);
    };

     const handleValueChange = (value) => {
        setIncomeAmount(value);
    };

   useEffect(() => {
  if (foundRemitance?.items) {
    const mapped = foundRemitance.items.map((item, index) => ({
      sn: index + 1,
      accountName: item.item?.id,
      accountCode: item.item?.gl_code,
      amount: item.amount,
    }));
    setFormData(mapped);
  }
  if (foundRemitance?.transaction_date) {
    setSelectedDate(foundRemitance.transaction_date);
  }
   if (foundRemitance?.description) {
    setDescription(foundRemitance.description);
  }
   if (foundRemitance?.amount) {
    setIncomeAmount(foundRemitance.amount);
  }

  if (foundRemitance?.debit_account) {
    setSelectedDebitAccount(foundRemitance.debit_account.id);
  }
}, [foundRemitance]);

const handlePrint = (id) => {
  handleOpenModal();
  const selectedLedger = ledgTableData.find(item => item.id === id);
  setFoundRemitance(selectedLedger);
  console.log(selectedLedger); // use this instead of FormData
};

 const handleTrashClick = async (id) => {
      const confirmed = await Swal.fire({
        title: 'Are you sure?',
        text: 'You are about to delete this remittance.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel',
      });
  
      if (!confirmed.isConfirmed) {
        return; // User canceled, do nothing
      }
  
      try {
        const response = await axios.get(`${BASE_URL}/delete-remittance?id=${id}`, { headers });
        fetchReceipt();
        Swal.fire({
          icon: 'success',
          title: 'Successful',
          text: response.data.message,
        });
      } catch (error) {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            errorMessage = JSON.stringify(error.response.data.message);
          }
          Swal.fire({
            icon: 'error',
            title: 'Failed',
            text: JSON.stringify(error.response.data.message),
          });
          console.log(errorMessage);
        }
      }
    };

 const fetchDebit1 = async () => {
        setLoading(true);
    
        try {
          const response = await axios.get(`${BASE_URL}/get-loans-receivables`,{headers});
        
          const debt1 = response.data?.data;
          const oopt1 = debt1.map((item) => ({
            label: item.gl_name,
            value: item.id,
         
            
          }));
          setDebit1(oopt1);

        if (foundRemitance && foundRemitance.account?.debit) {
          const slctedDebit = oopt1.find(item => item.value === foundRemitance.account?.debit.id);
          console.log(slctedDebit);
          setSelectedDebitAccount(slctedDebit);
        }
    
      
        } catch (error) {
          const errorStatus = error.response.data.message;
          console.error(errorStatus);
        } finally {
          setLoading(false);
        }
      };

        useEffect(() => {
        if (bearer) {
           fetchDebit1();
        }
    }, [bearer,foundRemitance]);
 const fetchIncome = async () => {
        setLoading(true);
    
        try {
          const response = await axios.get(`${BASE_URL}/get-account-by-class-id?class_id=${4}`,{headers});
        //     {
             
        //       headers: { 
        //         'Content-Type': 'application/json',
        //         'Authorization': `Bearer ${bearer}`
        //       }
        //     }
        //   );
          const inc = response.data?.data;

          setIncome(inc);
    
        //   console.log(debitAcc, "Debit Accounts");
        } catch (error) {
          const errorStatus = error.response.data.message;
          console.error(errorStatus);
        } finally {
          setLoading(false);
        }
      };

      useEffect(() => {
        fetchIncome();
    }, [bearer]);

    const handleCustomerChange = (selectedOption) => {
      setSelectedCustomer(selectedOption.value);
    };

     const handleAssetChange = (selectedOption) => {
        setSelectedDebitAccount(selectedOption.value);
    };


const exportStaffLoanToExcel = async () => {
  if (actionLoading) return;

  setActionLoading("excel");

  try {
    const allLoans = await fetchAllStaffLoans(selectedLoan);

    const worksheetData = allLoans.map((item, index) => ({
      "S/N": index + 1,
      Date: item.transaction_date || "",
      "Staff Name": item.beneficiary?.name || "",
      "Staff ID": item.beneficiary?.employee_no || "",
      "Loan Name": item.loan?.description || "",
      "Total Amount": parseFloat(item.balance || 0).toLocaleString("en-US", {
        minimumFractionDigits: 2,
      }),
    }));

    const worksheet = XLSX.utils.json_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Staff Loans");
    XLSX.writeFile(workbook, "Staff_Loans.xlsx");
  } finally {
    setActionLoading(null);
  }
};

const exportStaffLoanToPDF = async () => {
  if (actionLoading) return;

  setActionLoading("pdf");

  try {
    const allLoans = await fetchAllStaffLoans(selectedLoan);

    const doc = new jsPDF();
    doc.setFontSize(14);
    doc.text("Staff Loan Report", 14, 15);

    const tableColumn = [
      "S/N",
      "Date",
      "Staff Name",
      "Loan Name",
      "Total Amount",
    ];

    const tableRows = allLoans.map((item, index) => [
      index + 1,
      item.transaction_date || "",
      item.beneficiary?.name || "",
      item.loan?.description || "",
      parseFloat(item.balance || 0).toLocaleString("en-US", {
        minimumFractionDigits: 2,
      }),
    ]);

    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 25,
      styles: { fontSize: 9 },
      headStyles: { fillColor: [22, 160, 133] },
    });

    doc.save("Staff_Loans.pdf");
  } finally {
    setActionLoading(null);
  }
};


  return (
     <div className={classes.topTopT} >
 <Modal
  show={showModal}
  onHide={handleCloseModal}
  size="lg"
  centered
  backdrop="static"
  scrollable
  className={classes.customModal}
>
  {/* Header */}
  <Modal.Header closeButton>
    <Modal.Title className="h5">Update Loans</Modal.Title>
  </Modal.Header>

  {/* Body */}
  <Modal.Body>
    <Form style={{ paddingLeft: "20px", paddingRight: "20px" }}>
      {/* Customer + Transaction Date */}
      <Row className="mb-3 g-3">
        <Col md={6}>
          <Form.Group>
            <Form.Label>Customer</Form.Label>
            <Select
              value={selectedCustomer}
              isLoading={loading}
              options={customerList}
              placeholder="Select Customer"
              onChange={setSelectedCustomer}
              menuPortalTarget={document.body}
              styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
            />
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group>
            <Form.Label>Transaction Date</Form.Label>
            <Form.Control
              type="date"
              value={selectedDate}
              onChange={handleDateChange}
              min={minDate}
              max={maxDate}
              size="sm"
            />
          </Form.Group>
        </Col>
      </Row>

      {/* Description */}
      <Row className="mb-3">
        <Col>
          <Form.Group>
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={2}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </Form.Group>
        </Col>
      </Row>

      {/* Debit Account + Amount */}
      <Row className="mb-3 g-3">
        <Col md={6}>
          <Form.Group>
            <Form.Label>Debit Account</Form.Label>
            <Select
              value={selectedDebitAccount}
              isLoading={loading}
              options={debit1}
              placeholder="Select Debit GL"
              onChange={setSelectedDebitAccount}
              menuPortalTarget={document.body}
              styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
            />
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group>
            <Form.Label>Amount</Form.Label>
            <CurrencyInput
              name="amount"
              decimalsLimit={2}
              className="form-control text-end"
              value={incomeAmount}
              onValueChange={handleValueChange}
            />
          </Form.Group>
        </Col>
      </Row>

      {/* Table */}
      <div
        className="table-responsive mb-3"
        style={{ maxHeight: "250px", overflowY: "auto" }}
      >
        <table className="table table-bordered table-hover table-sm align-middle text-center mb-0">
          <thead className="table-light small">
            <tr>
              <th className="py-1 px-2">#</th>
              <th className="py-1 px-2" style={{ width: "40%", fontWeight: 400 }}>
                Account Name
              </th>
              <th className="py-1 px-2">Account Code</th>
              <th className="py-1 px-2">Amount</th>
              <th className="py-1 px-2">
                <Button variant="primary" size="sm" onClick={addRow}>
                  <FaPlus size={12} color="white" />
                </Button>
              </th>
            </tr>
          </thead>
          <tbody>
            {formData?.map((row, index) => (
              <tr key={index}>
                <td className="align-middle">{row.sn}</td>
                <td className="align-middle">
                  <Form.Select
                    value={row.accountName}
                    onChange={(e) => handleAccountChange(index, e)}
                    size="sm"
                  >
                    <option value="">Select Account</option>
                    {income.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.gl_name}
                      </option>
                    ))}
                  </Form.Select>
                </td>
                <td className="align-middle">
                  <Form.Control
                    type="text"
                    value={row.accountCode}
                    readOnly
                    disabled
                    size="sm"
                  />
                </td>
                <td className="align-middle">
                  <CurrencyInput
                    name={`rowAmount-${index}`}
                    value={row.amount}
                    className="form-control form-control-sm text-end"
                    onValueChange={(value) => handleValueChange1(value, index)}
                  />
                </td>
                <td className="align-middle">
                  <Button variant="danger" size="sm" onClick={() => deleteRow(index)}>
                    <FaTrash size={12} />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Totals */}
      <Row className="mt-3 justify-content-end">
        <Col md={6}>
          <Row className="g-3">
            <Col>
              <Form.Group>
                <Form.Label>Total Debit</Form.Label>
                <CurrencyInput
                  name="totalDebit"
                  decimalsLimit={2}
                  className="form-control text-end"
                  value={incomeAmount}
                  disabled
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>Total Credit</Form.Label>
                <CurrencyInput
                  name="totalCredit"
                  decimalsLimit={2}
                  className="form-control text-end"
                  value={totalCredit}
                  disabled
                />
              </Form.Group>
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  </Modal.Body>

  {/* Footer */}
  <Modal.Footer style={{ paddingLeft: "20px", paddingRight: "20px" }}>
    <Button variant="light" onClick={handleCloseModal}>
      Cancel
    </Button>
    <Button
      variant="success"
      disabled={parseFloat(incomeAmount) !== parseFloat(totalCredit)}
      onClick={createIncome}
      className={classes.btnss}
    >
      {incomeLoading ? (
        <>
          <Spinner size="sm" />
          <span className="ms-2">Processing...</span>
        </>
      ) : (
        "Update Loans"
      )}
    </Button>
  </Modal.Footer>
</Modal>


  <Modal 
  show={show}
  onHide={handleClose}
  size="xl"
  centered
  backdrop="static"
>
  {/* Header */}
  <Modal.Header closeButton>
    <Modal.Title>Add New Remittance</Modal.Title>
  </Modal.Header>

  {/* Body */}
  <Modal.Body>
    <Form>
      {/* Row 1: Customer + Transaction Date */}
      <div className="row">
        <div className="col-md-6">
          <Form.Group>
            <Form.Label className={classes.formLabelCustom}>
              Customer
            </Form.Label>
            <Select
              isLoading={loading}
              options={customerList}
              placeholder="Select Customer"
              onChange={handleCustomerChange}
              value={selectedCustomer}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
            />
          </Form.Group>
        </div>

        <div className="col-md-6">
          <Form.Group>
            <Form.Label className={classes.formLabelCustom}>
              Transaction Date
            </Form.Label>
            <Form.Control
              className={classes.formControl}
              type="date"
              value={selectedDate}
              onChange={handleDateChange}
              min={minDate}
              max={maxDate}
            />
          </Form.Group>
        </div>
      </div>

      {/* Row 2: Description */}
      <div className="row mt-3">
        <div className="col-12">
          <Form.Group>
            <Form.Label className={classes.formLabelCustom}>
              Description
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={2}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              name="description"
            />
          </Form.Group>
        </div>
      </div>

      {/* Row 3: Debit Account + Amount */}
      <div className="row mt-3">
        <div className="col-md-6">
          <Form.Group>
            <Form.Label className={classes.formLabelCustom}>
              Debit Account
            </Form.Label>
            <Select
              isLoading={loading}
              options={debit1}
              placeholder="Select Debit GL"
              onChange={handleAssetChange}
              value={selectedDebitAccount}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
            />
          </Form.Group>
        </div>

        <div className="col-md-6">
          <Form.Group>
            <Form.Label className={classes.formLabelCustom}>
              Amount
            </Form.Label>
            <CurrencyInput
              name="amount"
              decimalsLimit={2}
              className="form-control"
              value={incomeAmount}
              onValueChange={handleValueChange}
              style={{ textAlign: "right" }}
            />
          </Form.Group>
        </div>
      </div>

      {/* Table */}
      <div className="table-responsive mt-4">
        <table className="table table-bordered table-hover align-middle">
          <thead className="table-light text-center">
            <tr>
              <th>#</th>
              <th style={{ width: "40%" }}>Account Name</th>
              <th>Account Code</th>
              <th>Amount</th>
              <th>
                <Button 
                  // style={{ borderRadius: 80 }} 
                  variant="primary" 
                  onClick={addRow}
                >
                  <i className="fas fa-plus"></i>
                </Button>
              </th>
            </tr>
          </thead>
          <tbody className="text-center">
            {formData?.map((row, index) => (
              <tr key={index}>
                <td>{row.sn}</td>
                <td>
                  <Form.Select
                    value={row.accountName}
                    onChange={(e) => handleAccountChange(index, e)}
                  >
                    <option value="">Select Account</option>
                    {income.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.gl_name}
                      </option>
                    ))}
                  </Form.Select>
                </td>
                <td>
                  <Form.Control
                    type="text"
                    value={row.accountCode}
                    readOnly
                    disabled
                  />
                </td>
                <td>
                  <CurrencyInput
                    name={`rowAmount-${index}`}
                    value={row.amount}
                    className="form-control"
                    onValueChange={(value) => handleValueChange1(value, index)}
                    style={{ textAlign: "right" }}
                  />
                </td>
                <td>
                  <Button 
                    variant="danger" 
                    onClick={() => deleteRow(index)}
                  >
                    <i className="fas fa-trash"></i>
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Totals */}
      <div className="row mt-4">
        <div className="col-md-6 offset-md-6">
          <div className="d-flex justify-content-between">
            <Form.Group className="me-3">
              <Form.Label>Total Debit</Form.Label>
              <CurrencyInput
                name="totalDebit"
                decimalsLimit={2}
                className="form-control"
                value={incomeAmount}
                disabled
                style={{ textAlign: "right" }}
              />
            </Form.Group>

            <Form.Group>
              <Form.Label>Total Credit</Form.Label>
              <CurrencyInput
                name="totalCredit"
                decimalsLimit={2}
                className="form-control"
                value={totalCredit}
                disabled
                style={{ textAlign: "right" }}
              />
            </Form.Group>
          </div>
        </div>
      </div>
    </Form>
  </Modal.Body>

  {/* Footer */}
  <Modal.Footer>
    <Button variant="secondary" onClick={handleClose}>
      Cancel
    </Button>
    <Button
      variant="success"
      disabled={parseFloat(incomeAmount) !== parseFloat(totalCredit)}
      onClick={createIncome}
    >
      {incomeLoading ? (
        <>
          <Spinner size="sm" />
          <span className="ms-2">Processing...</span>
        </>
      ) : (
        "Add Remittance"
      )}
    </Button>
  </Modal.Footer>
</Modal>


      <HeaderNav />

      <div className={classes.topContainer}>
        <div className={classes.topNavBars}>
          <Button className={classes.buttonsNav}>Remitances</Button>
          <Button className={classes.buttonsNav}>Petty Cash</Button>
          <Button className={classes.buttonsNav}>Supplier's Payment</Button>
          <Button className={classes.buttonsNav}>Customer's Leger</Button>
        </div>
        <div style={{ marginTop: 24 }} />
        <h3 className={classes.topText}>Staff Loan</h3>
        <p className={classes.prgText}>View, Upload Staff Loans</p>
        <Row style={{ marginTop: 16 }}>
  <Col md={3}>
    <div className={classes.thrdkad}>
      <p className={classes.kdptg}>Total Staff Ledger Balance</p>
      <p className={classes.kdptg1}>₦0.00</p>
      <div className={classes.rvnue}>
        <p className={classes.skaltxt}>Current balance</p>
      </div>
    </div>
  </Col>

  <Col md={3}>
    <div className={classes.frtkad}>
      <div className={classes.kad}>
        <p className={classes.kdptg}>Salary Credits</p>
        <p className={classes.kdptg2}>₦0.00</p>
        <div className={classes.rvnue}>
          <p className={classes.skaltxt}>Total credited salary</p>
        </div>
      </div>
    </div>
  </Col>

  <Col md={3}>
    <div className={classes.fiftkad}>
      <div className={classes.kad}>
        <p className={classes.kdptg}>Deductions</p>
        <p className={classes.kdptg3}>₦0.00</p>
        <div className={classes.rvnue}>
          <p className={classes.skaltxt}>Total deductions from salary</p>
        </div>
      </div>
    </div>
  </Col>

  <Col md={3}>
    <div className={classes.frstkad}>
      <div className={classes.kad}>
        <p className={classes.kdptg}>Pending Approvals</p>
        <p className={classes.kdptg4}>₦0.00</p>
        <div className={classes.rvnue}>
          <p className={classes.skaltxt}>Transactions awaiting approval</p>
        </div>
      </div>
    </div>
  </Col>
</Row>

        <div className={classes.subContainer}>
          <div style={{
            display: 'flex',
            gap: 16,
            alignItems: 'center'
          }}>
            <div className={classes.flexFlex}>
               <div style={{ marginTop: 10, width:"100%" }} >
                      <label for="example-text-input" style={{ textAlign: "right" }}>Loan Type</label>
                      <div style={{ width: '32%' }}>
                        <Select
                          value={loans.find((l) => l.value === selectedLoan) || null}
                          onChange={handleLoanTypeChange}
                          options={loans}
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            menu: (provided) => ({
                              ...provided,
                              maxHeight: '400px',
                              overflowY: 'auto',
                              fontSize: "12px",
                            }),
                          }}
                        />
                      </div>
                </div>
                <div className={classes.actionsicon}>
                 {/* <div
                    className={classes.iconbar}
                    style={{
                      cursor: actionLoading ? "not-allowed" : "pointer",
                      opacity: actionLoading === "print" ? 0.5 : 1,
                      pointerEvents: actionLoading ? "none" : "auto",
                    }}
                    // onClick={handlePrintk}
                  >
                    <OverlayTrigger placement="top" overlay={<Tooltip>Print payment</Tooltip>}>
                      <Printer size={28} />
                    </OverlayTrigger>
                    {actionLoading === "print" && <small>Printing...</small>}
                  </div> */}
                 <div
    className={classes.iconbar}
    style={{
      cursor: actionLoading ? "not-allowed" : "pointer",
      opacity: actionLoading === "excel" ? 0.5 : 1,
      pointerEvents: actionLoading ? "none" : "auto",
    }}
    onClick={exportStaffLoanToExcel}
    // ✅ exportStaffLoanToExcel (uses XLSX)


  >
    <FaFileExcel size={28} color="green" />
    {actionLoading === "excel" && <small>Downloading Excel...</small>}
               </div>
                <div
    className={classes.iconbar}
    style={{
      cursor: actionLoading ? "not-allowed" : "pointer",
      opacity: actionLoading === "pdf" ? 0.5 : 1,
      pointerEvents: actionLoading ? "none" : "auto",
      
    }}
    onClick={exportStaffLoanToPDF}
    // ✅ exportStaffLoanToPDF (uses jsPDF + autoTable)
  >
    <FaFilePdf color="red" size={28} />
    {actionLoading === "pdf" && <small>Generating PDF...</small>}
  </div>
               </div>
              <button className={classes.downBtn} onClick={() => setOpenJournalModal(true)}>
              <img src={upload} alt="upload" /> Upload Loan
            </button>

            <div className={classes.searchInputWrapper}>
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className={classes.searchInput}
                placeholder="Search staff loan..."
              />
              {searchTerm ? (
                <button
                  onClick={() => {
                    setSearchTerm("");
                    setSearchedResult([]);
                  }}
                  className={classes.clearBtn}
                >
                  ✕
                </button>
              ) : (
                <Search className={classes.searchIcon} size={16} />
              )}
            </div>
           
             </div>             
          </div>

        </div>
          {/* <div className={classes.threeBtns}>
            <a style={{marginLeft: 10}} href="https://account-api.patna.ng/api/v1/download-customer-template" download>
            <button className={classes.downBtn}>
              <img src={download} alt="download" /> Download Template
            </button>
            </a>                    
            <button className={classes.loanBtn} onClick={handleShow}>
              <img src={plus} alt="plus" /> Add New Beneficiary
            </button>
           
          </div> */}
        <div className={classes.tableContainer}>
          <table className={classes.tableTable}>
            <thead className={classes.tableHeader}>
              <tr>
                <th>S/N</th>
                <th>Date</th>
                <th>Staff Name</th>
                <th>Loan Name</th>
                <th>Total Amount</th>
                <th>Actions</th>
              </tr>
            </thead>
           <tbody>
  {benLoading ? (
    // Skeleton loading
    Array(5).fill().map((_, idx) => (
      <tr key={idx}>
        {Array(6).fill().map((_, i) => (
          <td key={i}>
            <Skeleton height={20} style={{ marginBottom: 10 }} />
          </td>
        ))}
      </tr>
    ))
  ) : isSearching ? (
    searchedResult.length === 0 ? (
      <tr>
        <td colSpan={7} style={{ textAlign: "center", color: "red" }}>
          No matching customers found
        </td>
      </tr>
    ) : (
      searchedResult.map((item, index) => (
        <tr key={index}>
          <td className={classes.textby}>{index + 1}</td>
          <td className={classes.textby}>{item.name}</td>
          <td className={classes.textby}>{item.email}</td>
          <td className={classes.textby}>{formatDate(item.created_at)}</td>
          <td className={classes.textby} style={{ textAlign: "right" }}>
            {parseFloat(item.balance).toLocaleString("en-US", {
              minimumIntegerDigits: 1,
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })}
          </td>
          <td className={classes.btnAction}>
            <button style={{ backgroundColor: "transparent", border: 0, cursor: "pointer" }}>
              <img src={EyeIcon} />
            </button>
            <button style={{ backgroundColor: "transparent", border: 0, cursor: "pointer" }}>
              <img src={PencilIcon} />
            </button>
            <button style={{ backgroundColor: "transparent", border: 0, cursor: "pointer" }}>
              <img src={DeleteIcon} />
            </button>
          </td>
        </tr>
      ))
    )
  ) : tableData.length === 0 ? (
    // ✅ Handle empty tableData
    <tr>
      <td colSpan={7} style={{ textAlign: "center", color: "gray" }}>
        No data available
      </td>
    </tr>
  ) : (
    // Default tableData
    tableData.map((item, index) => (
      <tr key={index}>
        <td className={classes.textby}>{index + 1}</td>
        <td className={classes.textby}>{item.transaction_date}</td>
        <td className={classes.textby}>{item.beneficiary?.name}</td>
         <td className={classes.textby}>{item.loan?.description}</td>
         <td style={{ textAlign: "right" }} className={classes.textby}>{parseFloat(item.balance).toLocaleString('en-US', {
                                            minimumIntegerDigits: 1,
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                          })}</td>
        <td className={classes.btnAction} style={{ textAlign: "center" }}>
          <button
            style={{ backgroundColor: "transparent", border: 0, cursor: "pointer" }}
            onClick={() => handlePrint(item?.id)}
          >
            <img src={EyeIcon} />
          </button>
          <button style={{ backgroundColor: "transparent", border: 0, cursor: "pointer" }} onClick={() => handleTrashClick(item.id)}>
            <img src={DeleteIcon} />
          </button>
        </td>
      </tr>
    ))
  )}
</tbody>


          </table>
          {!isSearching && (
            <div className={classes.paginationStyle}>
              <div className={classes.footerSubOne}>
                <button onClick={handlePrevPage}
                  disabled={currentPage === 1} className={classes.btnFirst}>Prev</button>
                {[...Array(totalPages)].map((_, page) => {
                 
                  if (page < 5 || page === currentPage - 1 || page === totalPages - 1) {
                    return (
                      <span key={page + 1} className={classes.ftOne}>
                        <button
                          className={`${classes.pageNumber} ${currentPage === page + 1 ? classes.active : ""}`}
                          onClick={() => setCurrentPage(page + 1)}
                        >
                          {page + 1}
                        </button>
                      </span>
                    );
                  }
                })}


                <button className={classes.btnSec} onClick={handleNextPage}
                  disabled={currentPage === totalPages}>Next</button>
              </div>
              <p className={classes.displayPag}>Displaying {`Page ${currentPage} - ${totalPages} pages`} of {formattedTotalEntries} entries</p>
            </div>
          )}


        </div>
      </div>
      {loading && (
        <div className={classes.overlay}>
          <img src={logo} alt="Loading..." className={classes.spinnerLogo} />
        </div>
      )}
      {uploading && (
        <div className={classes.overlay}>
          <img src={logo} alt="Loading..." className={classes.spinnerLogo} />
        </div>
      )}
        <StaffLoanModal
            isOpen={openJournalModal}
            onClose={() => setOpenJournalModal(false)}
        />
      
    </div>
  )
}

export default StaffLoan